import { styled } from '@mui/material/styles';

export const VerticalItemsContainer = styled('div')<{ $spacing?: number }>(
  ({ theme, $spacing }) => ({
    display: 'flex',
    flexFlow: 'column wrap',
    gap: theme.spacing($spacing || 2),
  }),
);
